import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllFinancialCategories = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/financial-categories',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveFinancialCategory = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/financial-categories',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateFinancialCategory = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/financial-categories/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteFinancialCategory = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/financial-categories/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllFinancialCategories,
  saveFinancialCategory,
  deleteFinancialCategory,
  updateFinancialCategory,
}
